import React from 'react';
import '/public/css/pages/forYou.css';
import '/public/css/pages/collection.css';
import ForYouSubNav from 'components/ForYouSubNav/ForYouSubNav';

const ForYouInner = (props: {
  inner: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  current?: 'for-you' | 'stories';
}) => {
  return (
    <div className="for-you-container">
      <ForYouSubNav current={props.current} />
      {props.inner}
    </div>
  );
};

export default ForYouInner;
